<template>
  <div
    style="display: flex; flex-direction: column; gap: 16px; min-width: 800px;"
  >
    <!-- Tags Selecionadas -->
    <div class="tags-wrapper" style="min-width: 800px;">
      <div class="tags-container">
        <b-badge
          v-for="cnae in selectedCnaes"
          :key="cnae"
          variant="info"
          class="tag-item"
          @click="removeTag(cnae)"
        >
          <span>{{ getCnaeText(cnae) }}</span>
          <b-icon-x-circle class="ml-1"></b-icon-x-circle>
        </b-badge>
      </div>
    </div>

    <!-- Dropdown de CNAEs -->
    <b-dropdown
      :disabled="disabled"
      text="Selecione CNAEs"
      variant="primary"
      class="mb-3"
    >
      <b-dropdown-form style="min-width: 800px; height: 100%;">
        <b-form-group label="Buscar CNAE:">
          <b-form-input
            v-model="search"
            placeholder="Digite para filtrar..."
            class="mb-2"
          ></b-form-input>
        </b-form-group>
        <div class="dropdown-scroll">
          <div v-if="isLoading" class="d-flex align-items-center mb-2">
            <b-spinner small type="grow" label="Carregando..." />
            <span class="ml-2">Carregando CNAEs...</span>
          </div>
          <b-form-checkbox
            v-if="!isLoading"
            v-for="cnae in filteredCnaes"
            :key="cnae.value"
            @change="handleChange"
            v-model="selectedCnaes"
            :value="cnae.value"
          >
            {{ cnae.text }}
          </b-form-checkbox>
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'CnaeSelect',
  props: {
    value: {
      type: Array,
      default: [],
    },
    selectedCities: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cnaeOptions: [],
      selectedCnaes: this.value,
      search: '',
      isLoading: false,
    };
  },
  computed: {
    filteredCnaes() {
      if (!this.search) return this.cnaeOptions;
      return this.cnaeOptions.filter(cnae =>
        cnae.text.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
  },
  async created() {
    // const storedOptions = localStorage.getItem('cnaeOptions');
    // if (storedOptions) {
    //   this.cnaeOptions = JSON.parse(storedOptions);
    //   return;
    // }
    await this.fetchCnaes();
  },
  watch: {
    selectedCities: {
      immediate: true,
      async handler() {
        await this.fetchCnaes();
      },
    },
  },
  methods: {
    async fetchCnaes() {
      if (this.disabled) return;
      this.isLoading = true;
      try {
        const { ok, model, errors } = await API.post('/execute', {
          path: `/lead-management/qualified-leads/cnaes?citiesList=${JSON.stringify(
            this.selectedCities,
          )}`,
          method: 'get',
        });

        if (!ok) {
          this.$bvToast.toast(errors.message, {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }

        const options = model.map(cnae => ({
          value: cnae.code,
          text: `${cnae.code} - ${cnae.description}`,
        }));

        this.cnaeOptions = options;
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: 'Erro',
          variant: 'error',
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },
    removeTag(value) {
      this.selectedCnaes = this.selectedCnaes.filter(cnae => cnae !== value);
      this.handleChange();
    },
    getCnaeText(value) {
      const cnae = this.cnaeOptions.find(c => c.value === value);
      return cnae ? cnae.text : value;
    },
    handleChange() {
      this.$emit('input', this.selectedCnaes);
    },
  },
};
</script>

<style scoped>
/* Dropdown Scroll */
.dropdown-scroll {
  height: 70vh;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 8px;
}

/* Wrapper para as tags */
.tags-wrapper {
  width: 400px; /* Largura Máxima */
  max-width: 400px;
  min-height: 40px;
  max-height: 80px; /* Altura Máxima */
  overflow-y: auto; /* Ativa scroll após atingir altura máxima */
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  background-color: #f8f9fa;
}

/* Container das Tags */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Estilo individual das tags */
.tag-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  max-width: 100%;
  word-break: break-word;
}

.tag-item:hover {
  background-color: #0056b3;
}

.tag-item .b-icon-x-circle {
  margin-left: 5px;
}

/* Estilização para o campo de busca */
.b-form-input {
  margin-bottom: 8px;
}
</style>
